import { SearchableCandidateBatchFilterInput } from 'generated-graphql/types';
import { buildAnalysisSearchClauses } from 'utils/buildAnalysisSearchClauses';

type GetSearchFilterParams = {
  organizationId: string;
  userId: string;
  debouncedSearchText: string;
  showOnlyMyAnalyses: boolean;
};

export const getSearchFilter = ({
  organizationId,
  userId,
  debouncedSearchText,
  showOnlyMyAnalyses
}: GetSearchFilterParams): SearchableCandidateBatchFilterInput => {
  const filter: SearchableCandidateBatchFilterInput = {
    organizationId: {
      eq: organizationId
    },
    ...(debouncedSearchText && {
      or: buildAnalysisSearchClauses(debouncedSearchText)
    }),
    ...(showOnlyMyAnalyses && {
      userId: {
        eq: userId
      }
    })
  };
  return filter;
};
